import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Checkbox } from 'seagull';
import { AiChipShell, GetAiFilterChipTID } from './AiChipShell';
import { chosenFirst, valueLabelFor } from './AiFilterChip.utils';
export const CheckboxesChip = (param)=>{
    let { testId, fieldLabel, items, selected, operator, searchable = false, isSelectedToBeOnTop = true, showAll = true, verb = 'toggle', valueLabel, tone, onApply, onRemove, biPrefix, autoOpen = false, texts } = param;
    const testIds = useMemo(()=>GetAiFilterChipTID(testId), [
        testId
    ]);
    const [query, setQuery] = useState('');
    const [orderedItems, setOrderedItems] = useState(()=>isSelectedToBeOnTop ? chosenFirst(items, selected) : items);
    const [draftAll, setDraftAll] = useState(selected.length === 0);
    const [draftValues, setDraftValues] = useState(selected);
    const hasValues = selected.length > 0;
    const isExclude = operator === 'exclude';
    const singleValue = selected.length === 1;
    const showToggle = singleValue && verb === 'toggle';
    const showStaticVerb = singleValue && verb === 'is';
    const visibleItems = searchable ? orderedItems.filter((item)=>item.label.toLowerCase().includes(query.trim().toLowerCase())) : orderedItems;
    const resetDraft = ()=>{
        setOrderedItems(isSelectedToBeOnTop ? chosenFirst(items, selected) : items);
        setDraftAll(selected.length === 0);
        setDraftValues(selected);
        setQuery('');
    };
    const toggleOption = (value)=>{
        setDraftAll(false);
        setDraftValues((current)=>current.includes(value) ? current.filter((entry)=>entry !== value) : [
                ...current,
                value
            ]);
    };
    const toggleSelectAll = ()=>{
        setDraftAll((current)=>!current);
        setDraftValues([]);
    };
    return /*#__PURE__*/ _jsxs(AiChipShell, {
        testId: testId,
        testIds: testIds,
        fieldLabel: fieldLabel,
        biPrefix: biPrefix,
        autoOpen: autoOpen,
        operator: showToggle ? {
            label: isExclude ? texts.isNot : texts.is,
            onToggle: ()=>onApply({
                    selected,
                    operator: isExclude ? 'include' : 'exclude'
                }),
            biName: "".concat(biPrefix, "_operator")
        } : undefined,
        valuePrefix: showStaticVerb ? texts.is : undefined,
        valueLabel: hasValues ? valueLabel !== null && valueLabel !== void 0 ? valueLabel : valueLabelFor(items, selected, texts) : texts.all,
        tone: tone,
        applyText: texts.apply,
        onOpen: resetDraft,
        onApply: ()=>onApply({
                selected: draftAll ? [] : [
                    ...draftValues
                ],
                operator
            }),
        onRemove: onRemove,
        search: searchable ? {
            value: query,
            onChange: setQuery
        } : undefined,
        children: [
            showAll && /*#__PURE__*/ _jsx(Checkbox, {
                testId: testIds.AiFilterChipTestIds.SelectAll(),
                bi: {
                    name: "".concat(biPrefix, "_select_all")
                },
                checked: draftAll,
                onChange: toggleSelectAll,
                label: texts.selectAll
            }),
            visibleItems.map((item)=>/*#__PURE__*/ _jsx(Checkbox, {
                    testId: testIds.AiFilterChipTestIds.Option(item.value),
                    bi: {
                        name: "".concat(biPrefix, "_option")
                    },
                    checked: !draftAll && draftValues.includes(item.value),
                    onChange: ()=>toggleOption(item.value),
                    label: item.label,
                    disabled: item.disabled
                }, item.value))
        ]
    });
};
